<template>
<div class="chapter">
<div class="inner_page">
<div>
<h2 class="chapter-title---IVP sigil_not_in_toc" id="_idParaDest-5"><a id="_idTextAnchor007"></a>Acknowledgments</h2>
<p class="veryfirst"><span class="first-words">To my patients, thank you</span> for the privilege of being your doctor. Your growth, your healing, your transformed lives have filled my life with joy. Thank you!</p>
<p class="body">To Christie, thank you for your patience, encouragement and support.</p>
<p class="body">To Simon Harrison, thank you for sharing your artistic talents and providing the diagram of the brain.</p>
<p class="body">To all my friends who have kept me in prayer, thank you; may this book be a blessing to you.</p>
<p class="body">All patient accounts described in this book are true. All names and identifying information have been changed to protect confidentiality. Some of the cases presented include information from multiple persons to further protect confidentiality. The cases presented in this book are selected to demonstrate problems that can arise when distorted views of God are held, and how a change in God-constructs can bring healing. However, not all patients have problems with their concepts of God, and changing a God-concept will not resolve all mental health problems. Many people suffer from illnesses that attack the physical brain, such as Alzheimer’s, schizophrenia, bipolar disorder and autism, and changing one’s God-concept will not resolve these disorders. Nevertheless it will be demonstrated that distorted God-concepts, while not directly causative of many disorders, are unhealthy, and holding to them will undermine health and healing.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ack.vue?5aaa6f17